var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExpand = function SvgExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 2C9.7 2 9 2.7 9 3.5S9.7 5 10.5 5h2.4l-3 2.9c-.6.6-.6 1.5 0 2.1.6.6 1.5.6 2.1 0l3-2.9v2.4c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5V2h-7.5zM8.5 19c.8 0 1.5-.7 1.5-1.5S9.3 16 8.5 16H6.1L9 13.1c.6-.6.6-1.5 0-2.1-.6-.6-1.5-.6-2.1 0L4 13.9v-2.4c0-.8-.7-1.5-1.5-1.5S1 10.7 1 11.5V19h7.5z"
  })));
};
export default SvgExpand;